import React, { Component } from 'react'
import styled from 'styled-components'
import {
  Card,
  FlexWrapper,
  Header,
  Footer,
  Input,
  ProductView,
  PageWrapper,
  Category,
  XXLText,
  SearchSuggestion,
  Button,
  IconMenu,
  Checkbox,
  XMText,
  Modal,
  XCMText,
  SecondaryHeader
} from '../components'
import { Formik, Form, Field } from 'formik'
import { upperlower } from '../utlis/functions'
import {
  get,
  debounce,
  flatMap,
  indexOf,
  toUpper,
  isEmpty,
  size,
  filter,
  lowerCase,
  intersection,
  uniqBy,
  replace
} from 'lodash'
import axios from 'axios'
import { API_URL } from '../constants'
import qs from 'qs'
import Cookies from 'js-cookie'
import { gsCalculator, priceRangeCalculator, filterHiddenData, isAdmin } from '../utlis/functions'
// import { JSONToFormData } from '../utlis/functions'

const SearchWrap = styled.div`
  margin: 10px 0 0px;
  /* padding-top: 10px; */
  overflow: auto;
  height: calc(100vh - 240px);
  ::-webkit-scrollbar {
    width: 10px;
  }
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: #124b5f;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: transparent;
  }
`
const Preview = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`
const IconWrap = styled.div`
  padding-top: 50px;
`
const ContentWrap = styled.div`
  background: #f5f5f5 !important;
`
const cateogories = [
  {
    name: 'Beverages',
    image: 'beverages_GC@3x.png'
  },
  {
    name: 'Bread and Bakery',
    image: 'bakery_and_bread@3x.png'
  },
  {
    name: 'Dairy and Eggs',
    image: 'dairy_and_eggs@3x.png'
  },
  {
    name: 'Deli',
    image: 'deli@3x.png'
  },
  {
    name: 'Frozen',
    image: 'frozen@3x.png'
  },
  {
    name: 'Meat',
    image: 'meat@3x.png'
  },
  {
    name: 'Miscellaneous ',
    image: 'miscellaneous_food_category_GC@3x.png'
  },
  {
    name: 'Pantry',
    image: 'pantry@3x.png'
  },
  {
    name: 'Prepared Foods',
    image: 'three-bunnies-803051-unsplash@3x.png'
  },
  {
    name: 'Produce',
    image: 'produce@3x.png'
  }
  // {
  //   name: 'Seafood',
  //   image: 'seafood@3x.png'
  // }
]

class Products extends Component {
  state = {
    favorite: false,
    search: '',
    recentlySearch: [],
    bestScores: [],
    bestForYou: [],
    productsData: [],
    recentlySearchAddedData: [],
    favouriteData: [],
    showSuggestions: false,
    bestScoresLoading: false,
    bestForYouLoading: false,
    recentlySearchLoading: false,
    comingSoonModel: false,
    grocers: [],
    filterStore: null,
    selectedStores: []
  }
  async componentDidMount() {
    const prevSearch = qs.parse(this.props.location.search.slice(1)).search
    await this.setState({ search: get(this.props, 'location.code', prevSearch ? prevSearch : '') })

    await this.setState({ selectedStores: Cookies.getJSON('selectedStores') })
    const searchFocus = get(this.props, 'location.state.searchFocus', false)

    if (searchFocus) {
      document.getElementById('searchFocusId').focus()
    }

    if (prevSearch) {
      this.getSearchData()
    }
    const warningQuery = {
      filter: { include: ['diets', 'allergies'] }
    }
    try {
      const { data } = await axios.get(`${API_URL}/users/${Cookies.get('user_id')}?${qs.stringify(warningQuery)}`)
      // console.log('userData==>', data)
      this.setState({ userData: data })
    } catch (error) {
      this.setState({ isLoading: false })
      console.log('ERROR', error)
    }

    this.getFavouriteData()
    this.fetchRecentlySearch()
  }

  fetchRecentlySearch = async () => {
    this.setState({ recentlySearchLoading: true })

    /* const productSearch = term => ({
      filter: {
        limit: 3,
        include: ['greenScores', 'productCost', 'users'],
        where: {
          productName: {
            like: `%${term}%`
          }
        },
        order: ['totalGs DESC']
      }
    }) */

    try {
      const { data: recentlySearchedTerms } = await axios.get(
        `${API_URL}/UserRecentSearchedProducts/get-popular-search?limit=${10}`
      )
      /* const products = await Promise.all(
        recentlySearchedTerms.map(async item => {
          const { data } = await axios.get(`${API_URL}/ProductTables?${qs.stringify(productSearch(item.searchTerm))}`)
          return data
        })
      ) */

      /* this.setState({
        recentlySearch: uniqBy(flatten(products), 'productCategory').slice(0, 3),
        recentlySearchLoading: false
      }) */

      this.setState({
        recentlySearch: recentlySearchedTerms,
        recentlySearchLoading: false
      })
    } catch (error) {
      console.log(error)
      this.setState({ recentlySearchLoading: false })
    }
  }

  getSearchData = debounce(async () => {
    this.props.history.push(`${this.props.location.pathname}?search=${this.state.search}`)

    const selectedStoresFilter = !isEmpty(this.state.selectedStores)
      ? {
          and: [
            {
              productName: {
                like: `%${this.state.search}%`
              }
            },
            {
              activeGsSystem: {
                gte: 3
              }
            },
            {
              or: this.state.selectedStores.map(item => ({
                storeName: item
              }))
            }
          ]
        }
      : {
          productName: {
            like: `%${this.state.search}%`
          },
          activeGsSystem: {
            gte: 3
          }
        }
    const query = {
      filter: {
        limit: 50,
        include: ['productCost', 'users'],
        where: selectedStoresFilter,
        order: ['totalGs DESC']
      }
    }

    try {
      const { data } = await axios.get(`${API_URL}/product_cost_details`, { params: { filter: query.filter } })

      this.setState({ productsData: uniqBy(filter(data, item => item.productCost), 'productCode') })
    } catch (error) {
      this.setState({ isLoading: false })
      console.log(error)
    }
    try {
      const { data: recentlySearchAddedData } = await axios.post(
        `${API_URL}/UserRecentSearchedProducts/addUserRecentSearchedProduct`,
        {
          userId: Cookies.get('user_id'),
          searchTerm: this.state.search
        }
      )
      this.setState({ recentlySearchAddedData })
    } catch (error) {
      console.log(error)
    }
  }, 400)
  onStoreChange = () => {
    //get stores
    const selectedStores = Cookies.getJSON('selectedStores')
    // change state to the selected stores
    this.setState({ selectedStores }, this.componentDidMount)
    // change the filters
  }

  updateRecentSearch = async productCode => {
    try {
      await axios.patch(
        `${API_URL}/UserRecentSearchedProducts/${get(this.state, 'recentlySearchAddedData.data.body.id', 'NULL')}`,
        {
          ...this.state.recentlySearchAddedData.data.body,
          productCode
        }
      )
    } catch (error) {
      console.log(error)
    }
  }

  getFavouriteData = async () => {
    try {
      const { data } = await axios.get(
        `${API_URL}/users/${Cookies.get('user_id')}/productTables?filter=%7B%22fields%22%3A%22productCode%22%7D`
      )
      // console.log('--------', data)
      this.setState({ favouriteData: data })
    } catch (error) {
      console.log('ERROR', error)
    }
  }

  changeFavouriteData = async id => {
    const query = {
      filter: {
        where: { userId: Cookies.get('user_id'), productCode: id }
      }
    }
    const { data } = await axios.get(`${API_URL}/UserProducts?${qs.stringify(query)}`)
    if (data.length === 0) {
      await axios.post(`${API_URL}/UserProducts`, {
        productCode: id,
        userId: Cookies.get('user_id')
      })
      this.getFavouriteData()
    } else {
      await axios.delete(`${API_URL}/UserProducts/${data[0].id}`)
      this.getFavouriteData()
    }
  }

  filterData = productData => {
    if (!this.state.filterStore) {
      return productData
    } else {
      return productData.filter(item => {
        return item.productCost.map(p => p.storeName).indexOf(this.state.filterStore) > -1
      })
    }
  }
  render() {
    const { search, productsData, favouriteData, showSuggestions, userData, comingSoonModel, grocers } = this.state
    const favouriteDataz = flatMap(favouriteData, 'productCode')
    const userDiets = get(userData, 'diets', []).map(item => lowerCase(item.diet))
    const userAllergies = get(userData, 'allergies', []).map(item => lowerCase(item.allergy))

    // const userDetails = Cookies.getJSON('userDetails')
    return (
      <React.Fragment>
        {isEmpty(search) ? (
          <Header title="Search" showProfile onClickProfile={() => this.props.history.push('/user-profile')} />
        ) : (
          <Header
            title="Search"
            showProfile
            onClickProfile={() => this.props.history.push('/user-profile')}
            icon="arrowBack"
            onClickBack={() => this.setState({ search: '' })}
            color="#fff"
          />
        )}

        <PageWrapper viewPadding="22.4% 4.3% 26%" height="auto" modifyPadding="70px 16px 84px">
          <Formik
            enableReinitialize
            initialValues={{ search: search }}
            render={formikBag => (
              <Form>
                <Field
                  name="search"
                  render={({ field }) => (
                    <Input
                      {...field}
                      id="searchFocusId"
                      style={{ height: '40px' }}
                      placeholder="Search products"
                      namespace="Barcode Scanner"
                      onFocus={() => this.setState({ showSuggestions: true })}
                      onBlur={() =>
                        setTimeout(() => {
                          this.setState({ showSuggestions: false })
                        }, 200)
                      }
                      onKeyUp={e => {
                        this.setState({ search: get(e, 'target.value', '') })
                        this.getSearchData()
                      }}
                      // onClickIcon={() => search && this.setState({ search: '' })}
                      onClickIcon={e => {
                        if (e === 'close') {
                          document.getElementById('searchFocusId').focus()
                        }
                        return search ? this.setState({ search: '' }) : this.setState({ comingSoonModel: true })
                      }}
                      rightIconName="barcode"
                      autoComplete="off"
                      fixed
                    />
                  )}
                />
                <SecondaryHeader clicked={this.onStoreChange} padding="50px 0px 0" minWidth="calc(100% - 54px)" />
                {formikBag.values.search === '' && showSuggestions ? (
                  <Card
                    padding="16px"
                    boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)"
                    boxRadius="5px"
                    bgColor="#fff"
                    margin="55px 0 0 0"
                    position="absolute"
                    style={{ left: 'auto', top: '120px', width: 'calc(100% - 32px)' }}>
                    <FlexWrapper>
                      <XXLText color="#124b5f">Popular Searches</XXLText>
                      <FlexWrapper>
                        {this.state.recentlySearch.map(item => {
                          // console.log('item', item)
                          return (
                            <SearchSuggestion
                              label={item.searchTerm}
                              // onClick={() => this.props.history.push(`/products/${item.productCode}/green-score`)}
                              onClick={() => {
                                this.setState({ search: item.searchTerm })
                                this.getSearchData()
                              }}
                            />
                          )
                        })}
                      </FlexWrapper>
                    </FlexWrapper>
                  </Card>
                ) : formikBag.values.search === '' ? (
                  <React.Fragment>
                    <FlexWrapper direction="row" flexWrap="wrap" justifyContent="space-between" viewPadding="0 0 0 0">
                      {cateogories.map(item => (
                        <Category
                          title={upperlower(item.name, 'titlecase')}
                          image={require(`../static/images/${item.image}`)}
                          onClick={() => this.props.history.push(`/category/${item.name}`)}
                        />
                      ))}
                    </FlexWrapper>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <SearchWrap>
                      {get(filterHiddenData(this.filterData(productsData)), 'length', []) > 0 ? (
                        filterHiddenData(this.filterData(productsData)).map((item, index) => {
                          const priceRange = get(item, 'productCost', []).map(range =>
                            range.productPriceSale ? range.productPriceSale : range.productPriceOriginal
                          )

                          // const priceRange = get(item, 'productCost', []).map(range => {
                          //   return {
                          //     value: range.productPriceSale ? range.productPriceSale : range.productPriceOriginal,
                          //     zipCode: range.zipCode
                          //   }
                          // })
                          const allergyConflicts = get(item, 'allergyConflicts', '')
                            .replace(/(\r\n\t|\n|\r\t|\r)/gm, '')
                            .toLowerCase()
                            .split(',')
                            .map(item => item.trim())
                          const dietConflicts = get(item, 'dietConflicts', '')
                            .replace(/(\r\n\t|\n|\r\t|\r)/gm, '')
                            .toLowerCase()
                            .split(',')
                            .map(item => item.trim())
                          return (
                            <ProductView
                              conflict={
                                !isEmpty(intersection(userAllergies, allergyConflicts)) ||
                                !isEmpty(intersection(userDiets, dietConflicts))
                              }
                              favValue={item.users ? item.users.length : 0}
                              key={item.productCode}
                              imageUrl={item.productImage}
                              quantity={
                                size(get(item, 'productQuantity', '')) < 15
                                  ? toUpper(get(item, 'productQuantity', ''))
                                  : ''
                              }
                              productName={get(item, 'productName', '')}
                              // priceRange={priceRangeCalculatorNew(priceRange, get(userDetails, 'zipCode', ''))}
                              priceRange={priceRangeCalculator(priceRange)}
                              favoriteActive={indexOf(favouriteDataz, item.productCode) === -1 ? false : true}
                              onFavorite={() => this.changeFavouriteData(item.productCode)}
                              progressValue={Math.round(item.totalGs, 0)}
                              isFavorite
                              isHidden={isAdmin() && item.isHidden ? true : false}
                              onClick={async () => {
                                await this.updateRecentSearch(item.productCode)
                                this.props.history.push(`/products/${item.productCode}/green-score`)
                              }}
                              searchResults
                              cardMargin="0"
                            />
                          )
                        })
                      ) : (
                        <Preview>
                          <p style={{ textAlign: 'center' }}>No Result Found</p>
                          <FlexWrapper alignItems="center" viewMargin="auto 0">
                            <Button
                              label="Nominate a brand/product for scoring"
                              size="small"
                              margin="5px 0 0 0"
                              fontSize="15px"
                              volume="filled"
                              onClick={() =>
                                this.props.history.push({
                                  pathname: '/nominate-brand',
                                  state: {
                                    returnToSearch: true
                                  }
                                })
                              }
                            />
                          </FlexWrapper>
                        </Preview>
                      )}
                    </SearchWrap>
                  </React.Fragment>
                )}
              </Form>
            )}
          />
          <Modal
            show={comingSoonModel}
            hide={!comingSoonModel}
            onClose={() => this.setState({ comingSoonModel: false })}>
            <FlexWrapper alignItems="center">
              <XCMText>Coming Soon!</XCMText>
            </FlexWrapper>
          </Modal>
        </PageWrapper>
        <Footer />
      </React.Fragment>
    )
  }
}

export default Products



// WEBPACK FOOTER //
// ./src/pages/Products.js